export default "__VITE_ASSET__27db382f__"